import type { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';

import { AppServerResponse } from '../../utils/interfaces/generalInterfaces';
import {
  createSupplierFiledLienTemplate,
  createFiledLienTemplateByAdmin,
  getFiledLienTemplates,
  getFiledLienTemplatesByAdmin,
} from '../services/filedLienTemplatesService';
import { FiledLienTemplatesInitialState } from '../globalSlices/filedLienTemplatesSlice';

export const createFiledLienTemplateByAdminExtraReducer = (
  builder: ActionReducerMapBuilder<FiledLienTemplatesInitialState>
) => {
  const reducerId = 'createFiledLienTemplateByAdmin';
  builder.addCase(createFiledLienTemplateByAdmin.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    createFiledLienTemplateByAdmin.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    }
  );
  builder.addCase(createFiledLienTemplateByAdmin.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};
export const createSupplierFiledLienTemplateExtraReducer = (
  builder: ActionReducerMapBuilder<FiledLienTemplatesInitialState>
) => {
  const reducerId = 'createSupplierFiledLienTemplate';
  builder.addCase(createSupplierFiledLienTemplate.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    createSupplierFiledLienTemplate.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    }
  );
  builder.addCase(createSupplierFiledLienTemplate.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};
export const getFiledLienTemplatesExtraReducer = (
  builder: ActionReducerMapBuilder<FiledLienTemplatesInitialState>
) => {
  const reducerId = 'getFiledLienTemplates';
  builder.addCase(getFiledLienTemplates.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(getFiledLienTemplates.fulfilled, (state, action: PayloadAction<any | null>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    if (action.payload.success && action.payload.data) {
      state.filedLienTemplates = action.payload.data;
    }
  });
  builder.addCase(getFiledLienTemplates.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const getFiledLienTemplatesByAdminExtraReducer = (
  builder: ActionReducerMapBuilder<FiledLienTemplatesInitialState>
) => {
  const reducerId = 'getFiledLienTemplatesByAdmin';
  builder.addCase(getFiledLienTemplatesByAdmin.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    getFiledLienTemplatesByAdmin.fulfilled,
    (state, action: PayloadAction<any | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload.success && action.payload.data) {
        state.filedLienTemplatesByAdmin = action.payload.data;
      }
    }
  );
  builder.addCase(getFiledLienTemplatesByAdmin.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};
